import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import Asignatura from "../../containers/asignaturaContainer";
import { validateFechas } from "../../helpers";
import { getPuestos } from "../../actions/escuela-action";
import { API_BASE_URL } from "../../config/api";
import { Input, Col, Row, Space } from "antd";

const { Search } = Input;
export const procesaDatosProfesor = (data) => {
  const [situacionLaboralTipo] = data.situacionLaboral?.split(",") || [];

  return {
    ...data,
    claveCentroDeTrabajo: data.claveCentroDeTrabajo
      ?.split(",")
      .map((m) => parseInt(m)),
    situacionLaboralTipo: parseInt(situacionLaboralTipo),
  };
};

const ActualizaAsignatura = (props) => {

  // const [search, setsearch] = useState('');
  const [isProfesores, setIsProfesores] = useState(false);
  const [datosProfesor, setDatosProfesor] = useState({});
  const [asignaturas, setAsignaturas] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const puestos = useSelector((state) => state.escuela.puestos);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPuestos());
  }, []);

  const userData = sessionStorage.getItem("userAccessData");
  const userAccessDataObj = JSON.parse(userData)
     const userIdClaveZonasCentroTrabajo = userAccessDataObj.idClaveZonaCentroTrabajo;
  // const userIdClaveZonasCentroTrabajo = "2";
  //        COLT790406MMSRNR00 mercedes flores leon

  const procesaProfesor = async (profesorData) => {
    const { idProfesor, error, info, cargo } = profesorData;

    const llevaAsignaturas = puestos.find(
      (puesto) => puesto.idPuesto === cargo //antes idPuesto era nombre
    )?.llevaAsignaturas;

    console.log('llevaAsignaturasProcesaProfesor', llevaAsignaturas)
    const procesa = procesaDatosProfesor({ ...profesorData, llevaAsignaturas });
    setDatosProfesor(validateFechas(procesa));
    const asignaturas = await axios.get(
      `${API_BASE_URL}/PlantillaPersonalWS/webresources/Maestros/getAsignaturaProfesoresByIdProfesor?json=[{"idProfesor":${idProfesor}}]`
    );
    setAsignaturas(asignaturas.data);
  };

  const handleSearch = async (search) => {
    setAsignaturas({});
    setisLoading(true);
    const profesorData = await axios.get(
      // `${API_BASE_URL}/PlantillaPersonalWS/webresources/Maestros/getProfesoresByCURP?json=[{"curp":${search}}]`
      `${API_BASE_URL}/PlantillaPersonalWS/webresources/Maestros/getProfesoresByCURP?json=[{"curp":${search},"idClaveZonaCentroTrabajo":"${userIdClaveZonasCentroTrabajo}"}]`
    );

    // const filteredData= data.filter((d) => {
    //   return d.estatusRegistro  !== "Eliminado" 
    // })
    const { idProfesor, error, info, cargo } =
      profesorData?.data?.length === 1
        ? profesorData?.data[0]
        : profesorData?.data;
    if (profesorData.data.length === 0) { notify('CURP no existe') }
    if (error) {
      notify(`${info}: ${search}`);
      setDatosProfesor({});
      setisLoading(false);
      return null;
    }
   
    if (idProfesor) {
      const llevaAsignaturas = puestos.find(
        (puesto) => puesto.nombre === cargo
      )?.llevaAsignaturas;

      const procesa = procesaDatosProfesor({
        ...profesorData.data[0],
        llevaAsignaturas,
      });
      setDatosProfesor(validateFechas(procesa));
      const asignaturas = await axios.get(
        `${API_BASE_URL}/PlantillaPersonalWS/webresources/Maestros/getAsignaturaProfesoresByIdProfesor?json=[{"idProfesor":${idProfesor}}]`
      );
      setAsignaturas(asignaturas.data);
    } else if (profesorData?.data.length > 1) {
      setDatosProfesor(profesorData?.data);
      setIsProfesores(true);
    }
    setisLoading(false);
  };
  const notify = (info) => toast.dark(info);

  console.log('datosProfesorActAsign', datosProfesor)
  // console.log('llevaAsignaturas', llevaAsignaturas)
  return (
    <Row>
      <Space>
        {/* <h1>CURP :  </h1> */}

        <Col flex="470px">
          {/* <input value={search} onChange={({ target }) => setsearch(target.value)} /> */}
          {/* <button type='button' onClick={handleSearch}>Buscar</button> */}
          <Search
            placeholder="Inserta CURP"
            allowClear
            enterButton="Buscar"
            size="large"
            onSearch={handleSearch}
          />
          {Object.keys(datosProfesor).length > 0 &&
            Object.keys(asignaturas).length > 0 &&
            !isLoading && (
              <Asignatura
                path={props.location.pathname}
                setDatosProfesor={setDatosProfesor}
                datosProfesor={datosProfesor}
                asignaturas={asignaturas}
              />
            )}
          {isProfesores && (
            <table width="100%">
              <tr>
                <th>Nombre</th>
                <th>Clave Centro de Trabajo</th>
                <th></th>
              </tr>

              <tbody>
                {datosProfesor?.map((profe) => {
                  const {
                    nombre,
                    apellidoPaterno,
                    apellidoMaterno,
                    idClaveZonaCentroTrabajo,
                  } = profe;

                  return (
                    <tr>
                      <td>{`${nombre} ${apellidoPaterno} ${apellidoMaterno} `}</td>
                      <td>{idClaveZonaCentroTrabajo}</td>
                      <td>
                        <button
                          onClick={() => {
                            procesaProfesor(profe);
                            setIsProfesores(false);
                          }}
                        >
                          Seleccionar
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Col>
      </Space>
    </Row>
  );
};

export default ActualizaAsignatura;
